import axios from 'axios';
import {saveAs} from 'file-saver';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';

async function downloadAsset(url: string, fileName: string) {
  raiseFlashMessage({
    status: 'success',
    mode: 'light',
    message: translate('Download started'),
    duration: 3000,
  });
  const response = await axios.get(url, {
    responseType: 'blob',
  });
  const blob = new Blob([response.data], {
    type: response.headers['content-type'],
  });
  saveAs(blob, fileName);
}

export default downloadAsset;
